import PerfectScrollbar from 'perfect-scrollbar';
import React, { useEffect, useState } from 'react';
import { useLocation, Route, Routes, Outlet } from 'react-router-dom';

import DemoNavbar from '../components/Navbars/DemoNavbar';
import Footer from '../components/Footer/Footer';
import Sidebar from '../components/Sidebar/Sidebar';
import FixedPlugin from '../components/FixedPlugin/FixedPlugin.js';

// import NeuroBitRoutes from '../routes';
import routes, { ModelCentralRoutes } from '../routes';
import { applicationDataSelector } from '../store/slices/applicationData';
import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ConfirmModal from '../components/Modals/ConfirmModal';
import clientUtils from '../Utils/clientUtils';
import ProfileModalNewUser from '../components/Modals/ProfileModalNewUser';
import { useAuth0 } from '@auth0/auth0-react';
import { saveUserInfo, userInfoSelector } from '../store/slices/userInfo';
import { UserInfoDto } from '../models/APIModels';
import { useAppDispatch } from '../store/index';
import { LocalStorageService } from '../common/index';
import { ApiHelper } from '../common/ApiHelper';
import {  setAxiosTokenInterceptor } from '../common/Interceptor';
let ps;

const Layout = ({}) => {
  const [backgroundColor, setBackgroundColor] = React.useState('black');
  const [activeColor, setActiveColor] = React.useState('info');
  const { toastMessage, confirmMessage } = useSelector(applicationDataSelector);
  const mainPanel = React.useRef();
  const location = useLocation();
  const [showProfilePopUp, setShowProfilePopUp] = useState(false);
  const { getAccessTokenSilently, getIdTokenClaims, user, isAuthenticated } = useAuth0();
  const { userInfo } = useSelector(userInfoSelector);
  const dispatch = useAppDispatch();
  const [userInfoDetails, setUserInfoDetails] = useState<UserInfoDto | null>(null);

  React.useEffect(() => {
    // console.log(navigator.platform)
    if (clientUtils.getOSName() !== 'UnKnown OS') {
      ps = new PerfectScrollbar(mainPanel.current);
      document.body.classList.toggle('perfect-scrollbar-on');
    }
    return function cleanup() {
      if (clientUtils.getOSName() !== 'UnKnown OS') {
        ps.destroy();
        document.body.classList.toggle('perfect-scrollbar-on');
      }
    };
  });
  React.useEffect(() => {
    if (mainPanel && mainPanel.current) {
      mainPanel.current.scrollTop = 0;
    }
    // document.scrollingElement.scrollTop = 0;
    // console.log('location', location);
  }, [location]);

  useEffect(() => {}, [toastMessage]);

  const handleActiveClick = (color) => {
    setActiveColor(color);
  };
  const handleBgClick = (color) => {
    setBackgroundColor(color);
  };
  const init = async () => {
    try {
      const token = await getAccessTokenSilently();
      if (!userInfo && token) {
        const userInfo = await ApiHelper.GetUserInfo();
        dispatch(saveUserInfo(userInfo.data));
        // Redirect user to profile page on first time login
        // console.log('userInfo', userInfo)
        if (userInfo.status === 201) {
          setUserInfoDetails(userInfo.data);
          setShowProfilePopUp(true);
          // navigate(`/profile`);
        }
      }
    } catch (ex) {
      console.error('Unable to get data', ex);
    }
  };
  const getToken = async () => {
    try {
      const accessToken = await getAccessTokenSilently();
      if (accessToken) {
        LocalStorageService.setItem('ACCESS_TOKEN', accessToken);
        const nextAccessTokenRenewTime = new Date(Date.now() + 1000 * 60 * 4).getTime();
        LocalStorageService.setItem('ACCESS_TOKEN_EXPIRE', nextAccessTokenRenewTime);
        LocalStorageService.setItem('userInfo', user);
        // set new refresh token in the axios
        setAxiosTokenInterceptor(getAccessTokenSilently);
     
      }
    } catch (e) {
      console.error(e.message);
    }
  };
  useEffect(() => {
    if (isAuthenticated) {
      init();
      getToken();
      
    } else {
      setAxiosTokenInterceptor('system');
    }
  }, [getAccessTokenSilently]);

  useEffect(() => {
    // Updateing accessToekn when page is reloading
     
      if(isAuthenticated) {
        init();
        getToken();
      } else {
        setAxiosTokenInterceptor('system');
      }
  }, [isAuthenticated]);

  return (
    <div className="wrapper">
      {/* <Sidebar routes={routes} bgColor={backgroundColor} activeColor={activeColor} /> */}
      <div className="main-panel" ref={mainPanel}>
        <DemoNavbar />
        {/* <Outlet /> */}
        <ModelCentralRoutes />
        <ToastContainer />
        <ConfirmModal value={confirmMessage} />
        <Footer fluid />
      </div>
      {/* <FixedPlugin
        bgColor={backgroundColor}
        activeColor={activeColor}
        handleActiveClick={handleActiveClick}
        handleBgClick={handleBgClick}
      /> */}
      {showProfilePopUp && userInfoDetails && (
        <ProfileModalNewUser open={showProfilePopUp} userInfo={userInfoDetails} onClose={() => setShowProfilePopUp(false)} />
      )}
    </div>
  );
};

export default Layout;
